import type { DriveSectionId } from './types';
import DashboardIcon from '@mui/icons-material/Dashboard';
import InventoryIcon from '@mui/icons-material/Inventory';
import RouteIcon from '@mui/icons-material/Route';
import SchoolIcon from '@mui/icons-material/School';
import BadgeIcon from '@mui/icons-material/Badge';

export interface DriveSectionDefinition {
  id: DriveSectionId;
  label: string;
  blurb: string;
  helperText: string;
  icon: typeof DashboardIcon;
  colorGradient: { from: string; to: string };
}

export const DRIVE_SECTIONS: DriveSectionDefinition[] = [
  {
    id: 'overview',
    label: 'Overview',
    blurb: 'Central hub for resources and featured documents.',
    helperText: '',
    icon: DashboardIcon,
    colorGradient: { from: '#1976d2', to: '#42a5f5' }
  },
  {
    id: 'product',
    label: 'Product',
    blurb: 'Briefings, specifications, and collateral information regarding UFIT\'s products.',
    helperText: '',
    icon: InventoryIcon,
    colorGradient: { from: '#7b1fa2', to: '#ba68c8' }
  },
  {
    id: 'client-journey',
    label: 'Client Journey',
    blurb: 'Resources that guide client delivery end to end.',
    helperText: '',
    icon: RouteIcon,
    colorGradient: { from: '#00796b', to: '#4db6ac' }
  },
  {
    id: 'cpd',
    label: 'CPD',
    blurb: 'Continuing professional development plans, recordings, and certifications.',
    helperText: '',
    icon: SchoolIcon,
    colorGradient: { from: '#f57c00', to: '#ffb74d' }
  },
  {
    id: 'hr-information',
    label: 'HR Information',
    blurb: 'Policies, forms, and operational guidance.',
    helperText: '',
    icon: BadgeIcon,
    colorGradient: { from: '#c2185b', to: '#f06292' }
  }
];

export const DRIVE_SECTION_LABEL_MAP = DRIVE_SECTIONS.reduce<Record<DriveSectionId, string>>(
  (acc, section) => {
    acc[section.id] = section.label;
    return acc;
  },
  {
    'overview': 'Overview',
    'product': 'Product',
    'client-journey': 'Client Journey',
    'cpd': 'CPD',
    'hr-information': 'HR Information'
  }
);
